import { FaMapMarkerAlt, FaCalendarAlt, FaClock, FaPhoneAlt } from "react-icons/fa";
const centers = [
    {
      name: "Paldi",
      address: "Pritam Nagar Akhada, Dr Hariprasad Marg, Paldi, Ahmedabad, Gujarat 380007.",
      day: "Every Sunday",
      time: "8:00 AM – 9:30 AM",
      contact: "Hetal Panchal\n+91 93740 80920",
    },
    {
      name: "Sabarmati",
      address: "New Siddheshwar Ganesh Mandir, Near Railway Colony, Sabarmati, Ahmedabad, Gujarat 380019.",
      day: "Every Tuesday",
      time: "7:00 PM – 9:00 PM",
      contact: "Lakhan Sen\n+91 93758 38976",
    },
    {
      name: "Bopal",
      address: "Ravi School, Near HP Petrol Pump, Opp Sarkari Tubewell Road, Bopal, Ahmedabad, Gujarat 380058.",
      day: "Every Saturday",
      time: "7:00 PM – 9:00 PM",
      contact: "Vyshali Engineer\n+91 70969 81856 ",
    },
    {
      name: "Naroda",
      address: "Swastik Shikshan Sankul, Near Punjab National Bank, Naroda, Ahmedabad, Gujarat 380058.",
      day: "Every Friday",
      time: "7:00 PM – 9:00 PM",
      contact: "Ajit Rakheya\n+91 82008 07945",
    },
    {
      name: "Maninagar",
      address: "Vimlabai Chikhikar Hall, Dakshini Soc, Santosh Medical Galli, Maninagar, Ahmedabad, Gujarat 380008.",
      day: "Every Tuesday",
      time: "6:30 PM – 8:00 PM",
      contact: "Sneha Pungalia\n+91 84602 20567",
    },
    {
      name: "Nana Chiloda",
      address: "Nalanda Vidhyalay, Nandigram Soc, Opp Noblenagar, Airport Circle, Ahmedabad, Gujarat 380008.",
      day: "Every Sunday",
      time: "6:00 PM – 7:30 PM",
      contact: "Kavita Khokawat\n+91 92656 61512",
    },
  ];
  
  const MeditationCenters = () => {
    return (
      <section className="bg-[#f5f9f8] py-20 px-6" id="centers">
        <div className="text-center mb-12" data-aos="fade-up">
          <p className="text-sm text-green-700 font-semibold uppercase tracking-wide">
            Sahaja Yoga Centers
          </p>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Join Meditation Class in Ahmedabad
          </h2>
          <div className="space-x-4">
            <a
              href="/booklets/english.pdf"
              target="_blank"
              className="inline-block bg-gray-800 text-white px-5 py-2 rounded-full hover:bg-gray-700 transition"
            >
              English Booklet
            </a>
            <a
              href="/booklets/gujarati.pdf"
              target="_blank"
              className="inline-block bg-green-700 text-white px-5 py-2 rounded-full hover:bg-green-800 transition"
            >
              Gujarati Booklet
            </a>
          </div>
        </div>
  
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {centers.map((center, index) => (
            <div
              key={index}
              className="bg-white border border-green-100 shadow-md rounded-2xl p-6 hover:shadow-xl transition"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <h3 className="text-xl font-semibold text-green-800 mb-3">{center.name}</h3>
              <div className="space-y-2 text-sm text-gray-700">
                <p className="flex items-start gap-2">
                  <FaMapMarkerAlt className="text-green-500 mt-1" />
                  <span>{center.address}</span>
                </p>
                <p className="flex items-center gap-2">
                  <FaCalendarAlt className="text-blue-500" />
                  {center.day}
                </p>
                <p className="flex items-center gap-2">
                  <FaClock className="text-rose-500" />
                  {center.time}
                </p>
                <p className="flex items-start gap-2 whitespace-pre-line">
                  <FaPhoneAlt className="text-indigo-500 mt-1" />
                  <span>{center.contact}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };
  
  export default MeditationCenters;
  